<template>
  <b-modal 
    ref="modalMovimentacao" 
    id="modal-configuracao-movimentacao" 
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    centered
    size="lg"
    @shown="onModalShown"
  >
    <!-- Cabeçalho Premium -->
    <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" 
         style="background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%) !important;">
      <div class="header-icon-wrapper mr-3 bg-white-10">
        <i class="fa fa-exchange text-white"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">Configurações de Movimentação</h5>
        <small class="text-white opacity-75">Defina os parâmetros financeiros e contábeis do sistema</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fechar()">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div>

    <!-- Corpo do Modal -->
    <div class="p-4" style="max-height: 70vh; overflow-y: auto;">
      
      <!-- Grupo Financeiro -->
      <div class="modal-section-title mb-3">
        <i class="fa fa-money mr-2 text-primary"></i> Financeiro
      </div>
      <b-row>
        <b-col md="6">
          <b-form-group label="Banco" label-for="banco">
            <banco-drop-down 
              v-model="registro.COD_BANCO"
              :state="null"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Conta" label-for="conta">
            <conta-drop-down 
              v-model="registro.COD_CONTA"
              :state="null"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Histórico a Receber" label-for="hist-receber">
            <historico-drop-down 
              v-model="registro.COD_DESPRECEB"
              tipo="CREDITO"
              :state="null"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Histórico a Pagar" label-for="hist-pagar">
            <historico-drop-down 
              v-model="registro.COD_DESPPAGAR"
              tipo="DEBITO"
              :state="null"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Histórico Receb. Desconto" label-for="hist-desconto">
            <historico-drop-down 
              v-model="registro.COD_HISTORICO_RECEB_DESCONTO"
              tipo="CREDITO"
              :state="null"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Grupo de Pagamentos - A Pagar -->
      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-credit-card mr-2 text-danger"></i> Pagamentos - A Pagar
      </div>
      <b-row>
        <b-col md="6">
          <b-form-group label="Centro Custo Baixa Preferencial" label-for="centro-custo-pagar">
            <centro-custo-drop-down 
              v-model="registro.ID_CENTRO_CUSTO_BAIXA_PAGAR"
              :state="null"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Histórico Baixa Preferencial" label-for="hist-baixa-pagar">
            <historico-drop-down 
              v-model="registro.ID_PLANO_BAIXA_PAGAR"
              tipo="DEBITO"
              :state="null"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Histórico Abastecimento" label-for="hist-abastecimento">
            <historico-drop-down 
              v-model="registro.HISTORICO_ABASTECIMENTO_ID"
              tipo="DEBITO"
              :state="null"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Grupo Vales -->
      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-file-text mr-2 text-warning"></i> Vales
      </div>
      <b-row>
        <b-col md="6">
          <b-form-group label="Histórico Lançamento Vales" label-for="hist-vale">
            <historico-drop-down 
              v-model="registro.HISTORICO_VALE_ID"
              tipo="CREDITO"
              :state="null"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Grupo Controles -->
      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-cogs mr-2 text-info"></i> Controles
      </div>

      <b-row>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_GERAR_ARECEBER_NFE"
            value="1"
            unchecked-value="0"
          >
            Gera Contas a Receber por NFE de Saída
          </b-form-checkbox>
        </b-col>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_GERAR_ARECEBER_ROMANEIO"
            value="1"
            unchecked-value="0"
          >
            Gera Contas a Receber por Romaneio de Saída
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_VENDA_EXCLUI_ARECEBER"
            value="1"
            unchecked-value="0"
          >
            Excluir a Receber junto com a Venda
          </b-form-checkbox>
        </b-col>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_GERAR_APAGAR_NFE"
            value="1"
            unchecked-value="0"
          >
            Gera Contas a Pagar por NFe de Entrada
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_GERAR_APAGAR_ROMANEIO"
            value="1"
            unchecked-value="0"
          >
            Gera Contas a Pagar por Entradas
          </b-form-checkbox>
        </b-col>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_COMPRA_EXCLUI_APAGAR"
            value="1"
            unchecked-value="0"
          >
            Excluir a Pagar junto com a Compra
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_ESTORNAR_APAGAR_DIRETO"
            value="1"
            unchecked-value="0"
          >
            Estonar A Pagar direto no Caixa
          </b-form-checkbox>
        </b-col>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_ESTORNAR_ARECEBER_DIRETO"
            value="1"
            unchecked-value="0"
          >
            Estonar a Receber Direto no Caixa
          </b-form-checkbox>
        </b-col>
      </b-row>

    </div>

    <!-- Rodapé Premium -->
    <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
      <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="fechar()">
        CANCELAR
      </b-button>
      <b-button variant="success" pill class="px-5 font-weight-bold shadow-sm" @click="salvar()">
        <i class="fa fa-check-circle mr-1"></i> SALVAR
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import BancoDropDown from '../views/componentes/dropdown/BancoDropDown.vue'
import ContaDropDown from '../views/componentes/dropdown/ContaDropDown.vue'
import HistoricoDropDown from '../views/componentes/dropdown/HistoricoDropDown.vue'
import CentroCustoDropDown from '../views/componentes/dropdown/CentroCustoDropDown.vue'

export default {
  name: 'ModalConfiguracaoMovimentacao',
  components: {
    BancoDropDown,
    ContaDropDown,
    HistoricoDropDown,
    CentroCustoDropDown
  },
  data() {
    return {
      registro: {
        SEQUENCIA: 1,
        COD_BANCO: null,
        COD_CONTA: null,
        COD_DESPRECEB: null,
        COD_DESPPAGAR: null,
        COD_HISTORICO_RECEB_DESCONTO: null,
        ID_CENTRO_CUSTO_BAIXA_PAGAR: null,
        ID_PLANO_BAIXA_PAGAR: null,
        HISTORICO_ABASTECIMENTO_ID: null,
        HISTORICO_VALE_ID: null,
        OP_GERAR_ARECEBER_NFE: '0',
        OP_GERAR_ARECEBER_ROMANEIO: '0',
        OP_VENDA_EXCLUI_ARECEBER: '0',
        OP_GERAR_APAGAR_NFE: '0',
        OP_GERAR_APAGAR_ROMANEIO: '0',
        OP_COMPRA_EXCLUI_APAGAR: '0',
        OP_ESTORNAR_APAGAR_DIRETO: '0',
        OP_ESTORNAR_ARECEBER_DIRETO: '0'
      }
    }
  },
  methods: {
    abrir() {
      this.$refs.modalMovimentacao.show()
    },
    fechar() {
      this.$refs.modalMovimentacao.hide()
    },
    async carregarDados() {
      try {
        const { data } = await this.$http.get('/api/protected/parametro/getDados')
        if (data && data.length > 0) {
          this.registro = {
            ...this.registro,
            ...data[0],
            // Garantir valores default para checkboxes
            OP_GERAR_ARECEBER_NFE: data[0].OP_GERAR_ARECEBER_NFE || '0',
            OP_GERAR_ARECEBER_ROMANEIO: data[0].OP_GERAR_ARECEBER_ROMANEIO || '0',
            OP_VENDA_EXCLUI_ARECEBER: data[0].OP_VENDA_EXCLUI_ARECEBER || '0',
            OP_GERAR_APAGAR_NFE: data[0].OP_GERAR_APAGAR_NFE || '0',
            OP_GERAR_APAGAR_ROMANEIO: data[0].OP_GERAR_APAGAR_ROMANEIO || '0',
            OP_COMPRA_EXCLUI_APAGAR: data[0].OP_COMPRA_EXCLUI_APAGAR || '0',
            OP_ESTORNAR_APAGAR_DIRETO: data[0].OP_ESTORNAR_APAGAR_DIRETO || '0',
            OP_ESTORNAR_ARECEBER_DIRETO: data[0].OP_ESTORNAR_ARECEBER_DIRETO || '0'
          }
        }
      } catch (err) {
        console.error('Erro ao carregar configurações:', err)
        this.$root.$bvToast.toast('Erro ao carregar configurações', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
    },
    async salvar() {
      try {
        const { data } = await this.$http.post('/api/protected/parametro/update', {
          registro: this.registro
        })
        
        this.$root.$bvToast.toast(data.mensagem || 'Configurações salvas com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          autoHideDelay: 3000
        })
        
        this.fechar()
      } catch (err) {
        console.error('Erro ao salvar configurações:', err)
        this.$root.$bvToast.toast(err.response?.data || 'Erro ao salvar configurações', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
    },
    onModalShown() {
      this.carregarDados()
    }
  }
}
</script>

<style scoped>
.modal-header-premium {
  border-bottom: none;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.opacity-75 {
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/modals/ModalConfiguracaoMovimentacao.vue